<!-- Grid Highlight Wrapper -->

<!-- A11Y -->
<span hSrOnlyNoSnippet [attr.role]="'heading'" aria-level="3">
    {{ highlightedFilterGroupsSignal()[0]?.name }}
    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
    <span i18n="@@hermes-global-translations.filter"> filter </span>
</span>

<!-- Highlight items Template -->
<div class="grid-highlight">
    <h-carousel
        #carousel
        [slidesPerView]="2.5"
        [slidesPerGroup]="2"
        [a11yOptions]="carouselA11yOptions"
        [isMobile]="isMobileSignal()"
        [lazyLoadingOptions]="lazyLoadingOptions"
        [spaceBetween]="4"
        [breakpointsConfiguration]="breakpontsConfiguration"
        [controlsInset]="carouselControlsInset"
        [isControlsDisplayed]="highlightedFiltersSignal().length > nbSliderVisibles && !isMobileSignal()"
        [isDotsFocusable]="false"
        [centerInsufficientSlides]="highlightedFiltersSignal().length === this.minHighlightLength"
        (slidersPerViewChangeByBreakpoint)="onSlidersPerViewChangeByBreakpoint($event)">
        @for (highlightedItem of highlightedFiltersSignal(); track trackByHighlightedItems(idx, highlightedItem); let
        idx = $index) {

        <h-grid-highlight-item
            [highlightItemIndex]="idx"
            [highlightedItemFilter]="highlightedItem"
            [highlightedItemFilterGroup]="highlightedFilterGroupsSignal()[0]"
            (highlightFocus)="isMobileSignal() ? handleFocusItem(idx) : null"
            *hSlide></h-grid-highlight-item>

        }
    </h-carousel>
</div>
<!-- END Grid Highlight Wrapper -->
